// Generated by purs version 0.13.8
"use strict";
var Data_Either = require("../Data.Either/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_String_Regex = require("../Data.String.Regex/index.js");
var Data_String_Regex_Flags = require("../Data.String.Regex.Flags/index.js");
var Data_String_Utils = require("../Data.String.Utils/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var validatorFromRegex = Data_Either.either(Data_Function["const"](Data_Function["const"](false)))(Data_String_Regex.test);
var toHtml = function (text) {
    return Halogen_HTML_Elements.span_(Data_Foldable.foldr(Data_Foldable.foldableArray)(function (line) {
        return Data_Function.flip(Data_Semigroup.append(Data_Semigroup.semigroupArray))([ Halogen_HTML_Elements.br_, Halogen_HTML_Core.text(line) ]);
    })([  ])(Data_String_Utils.lines(text)));
};
var spaced = function (s) {
    return " " + (s + " ");
};
var showIndex = function (v) {
    if (v === 0) {
        return "first";
    };
    if (v === 1) {
        return "second";
    };
    if (v === 2) {
        return "third";
    };
    return Data_Show.show(Data_Show.showInt)(v - 1 | 0) + "th";
};
var indent = function (spaces) {
    var space = Data_String_Utils.unsafeRepeat(spaces)(" ");
    var $4 = Data_String_Common.joinWith("\x0a");
    var $5 = Data_Functor.map(Data_Functor.functorArray)(function (v) {
        return space + v;
    });
    return function ($6) {
        return $4($5(Data_String_Utils.lines($6)));
    };
};
var hasUppercase = validatorFromRegex(Data_String_Regex.regex("[A-Z]")(Data_String_Regex_Flags.noFlags));
var hasLowecase = validatorFromRegex(Data_String_Regex.regex("[a-z]")(Data_String_Regex_Flags.noFlags));
var doubleShow = function (dictShow) {
    var $7 = Data_Show.show(Data_Show.showString);
    var $8 = Data_Show.show(dictShow);
    return function ($9) {
        return $7($8($9));
    };
};
var containsDigits = validatorFromRegex(Data_String_Regex.regex(".*[0-9].*")(Data_String_Regex_Flags.noFlags));
module.exports = {
    indent: indent,
    toHtml: toHtml,
    spaced: spaced,
    validatorFromRegex: validatorFromRegex,
    hasUppercase: hasUppercase,
    hasLowecase: hasLowecase,
    containsDigits: containsDigits,
    showIndex: showIndex,
    doubleShow: doubleShow
};
